




























































































































































































































































































































































































































































































































































































































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { appModule } from "@/store/modules/app";
import PersonAutoComplete from "@/components/PersonAutoComplete.vue";
import VCDateTimePicker from "@/components/form_components/VCDateTimePicker.vue";
import IdentitasPasienRingkas from "@/components/pemeriksaan/order-darah/IdentitasPasienRingkas.vue";
import HasilDarahSvc from "@/services/HasilPemeriksaanDarah";
import { storeHasilPemeriksaanDarah } from "@/store/modules/HasilPemeriksaanDarahStore";
import {
  HasilDarahForm,
  HasilDarahBlok,
  HasilDarahJenis,
  HasilDarahKantong,
  HasilDarahKonteks,
  HasilDarahOrderKonteks,
  HasilDarahRecord,
  DokterPjOption
} from "@/types/hasil_pemeriksaan_darah";
import type { IdentitasRingkas } from "@/types/order_darah";
import {
  composeDate,
  toDateString,
  toTimeString
} from "@/utils/asesmenIntensifDateTime";

const KOSONG: any[] = [];

let seqKantong = 0;


function strToDate(nilai: string | null): Date | null {
  if (!nilai) return null;
  const t = String(nilai).trim();
  return composeDate(t.slice(0, 10), t.length >= 16 ? t.slice(11, 16) : "");
}

function dateToStr(nilai: Date | null): string | null {
  if (!nilai) return null;
  const tgl = toDateString(nilai);
  if (!tgl) return null;
  const jam = toTimeString(nilai) || "00:00";
  return `${tgl} ${jam}:00`;
}

@Component({
  components: { PersonAutoComplete, VCDateTimePicker, IdentitasPasienRingkas }
})
export default class HasilBankDarahFormDialog extends Vue {
  @Prop({ type: Boolean, default: false }) readonly value!: boolean;

  @Prop() readonly register!: string;

  @Prop() readonly rm!: string;

  @Prop({ default: null }) readonly editData!: HasilDarahRecord | null;

  @Prop({ type: String, default: "komponen_darah" })
  readonly jenis!: HasilDarahJenis;

  @Prop({ default: null }) readonly defaultPetugasId!: number | null;

  @Prop({ type: Boolean, default: false }) readonly readOnly!: boolean;

  saving = false;

  loadingKonteks = false;

  konteks: HasilDarahKonteks | null = null;

  form: HasilDarahForm = this.emptyForm();

  get dialog(): boolean {
    return this.value;
  }

  set dialog(val: boolean) {
    this.$emit("input", val);
  }

 
  get jenisAktif(): HasilDarahJenis {
    return this.editData && this.editData.jenis ? this.editData.jenis : this.jenis;
  }

  get labelJenis(): string {
    return this.meta ? this.meta.label : "Hasil Pemeriksaan Bank Darah";
  }

  get judul(): string {
    if (!this.editData) {
      const singkat = this.meta ? this.meta.label_singkat : "Bank Darah";
      return "Input Hasil Pemeriksaan " + singkat;
    }

    return this.editData.is_locked ? this.labelJenis : "Ubah " + this.labelJenis;
  }

  get judulGolongan(): string {
    const judul = this.meta && this.meta.judul_band ? this.meta.judul_band.golongan : null;
    return judul || "Pemeriksaan Golongan Darah Pasien";
  }

  
  get noSeksi(): Record<string, number> {
    let n = 0;
    const out: Record<string, number> = {};

    out.identitas = ++n;
    if (this.adaBand("golongan")) out.golongan = ++n;
    if (this.adaBand("crossmatch")) out.crossmatch = ++n;
    if (this.adaBand("coombs")) out.coombs = ++n;
    if (this.blok) out.blok = ++n;
    if (this.kantongTanpaUji) out.kantong = ++n;
    out.kesimpulan = ++n;
    out.ttd = ++n;

    return out;
  }

  get lockedForm(): boolean {
    return this.readOnly || !!(this.editData && this.editData.is_locked);
  }

  get pesanTerkunci(): string {
    if (this.readOnly && !(this.editData && this.editData.is_locked)) {
      return "Hasil hanya dapat diinput dan diubah dari unit Bank Darah — unit lain hanya melihat dan mencetak.";
    }
    return "Hasil sudah diverifikasi petugas pemeriksa — dokumen final dan tidak dapat diubah. Bila ada kekeliruan, batalkan order lewat Daftar Pasien Bank Darah.";
  }

  get identitasPasien(): Partial<IdentitasRingkas> {
    const k = this.konteks;
    const p: any = this.editData && this.editData.pasien ? this.editData.pasien : null;

    return {
      nama: (k && k.pasien.nama) || (p && p.nama) || "-",
      jk: (k && k.pasien.jk) || (p && p.sex) || "-",
      usia: (k && k.pasien.umur) || "-",
      alamat: (k && k.pasien.alamat) || (p && p.alamat) || "-",
      jaminan:
        (k && k.jaminan) || (this.editData && this.editData.label_jaminan) || "-"
    };
  }

  get katalog(): any {
    return storeHasilPemeriksaanDarah.katalog || {};
  }

  get meta(): any {
    const jenis = this.katalog.jenis || {};
    return jenis[this.jenisAktif] || null;
  }

 
  get bands(): string[] {
    if (this.meta && this.meta.bands) return this.meta.bands;
    if (this.editData && this.editData.bands) return this.editData.bands;
    return [];
  }

  
  get opsiDokterPj(): DokterPjOption[] {
    const daftar: DokterPjOption[] = (this.katalog.dokter_pj || []).slice();
    const tersimpan = this.editData && this.editData.dokter_pj;
    if (tersimpan && tersimpan.id && !daftar.some(d => d.id === tersimpan.id)) {
      daftar.push({ id: tersimpan.id, nama: tersimpan.nama || this.editData.dokter_pj_nama || "" });
    }
    return daftar;
  }

  get katalogBelumSiap(): boolean {
    return !this.meta;
  }

  adaBand(band: string): boolean {
    const bands = this.bands;
    return Array.isArray(bands) && bands.indexOf(band) >= 0;
  }

  get blok(): HasilDarahBlok | null {
    return this.meta && this.meta.blok ? this.meta.blok : null;
  }

  get kesimpulanBebas(): boolean {
    return !!(this.meta && this.meta.kesimpulan_bebas);
  }

  get labelKesimpulan(): string {
    return (this.meta && this.meta.label_kesimpulan) || "Kesimpulan";
  }

  get labelSaran(): string {
    return (this.meta && this.meta.label_saran) || "Saran";
  }

  bersihkanField(key: string) {
    if (this.lockedForm) return;
    this.$set(this.form.detail, key, "");
  }

  get pilihLainnya(): boolean {
    const blok = this.blok;
    if (!blok || !blok.lainnya_key) return false;

    const dipilih =
      this.form.detail && blok.key ? this.form.detail[blok.key] : null;

    return (
      Array.isArray(dipilih) &&
      dipilih.indexOf(blok.lainnya_value as string) >= 0
    );
  }

  get kantongTanpaUji(): boolean {
    return !this.adaBand("crossmatch") && !!(this.meta && this.meta.kantong && this.meta.kantong.max > 0);
  }

  get komponenItems(): any[] {
    return (this.katalog.komponen || KOSONG).slice();
  }

  get adaInkompatibel(): boolean {
    return this.form.kantong.some(k => k.hasil_uji_silang === "inkompatibel");
  }

  emptyDetail(): Record<string, string | string[]> {
    const blok = this.blok;
    if (!blok) return {};

    const out: Record<string, string | string[]> = {};

    if (blok.tipe === "fields") {
      Object.keys(blok.fields || {}).forEach(k => {
        out[k] = "";
      });

      return out;
    }

    out[blok.key as string] = blok.tipe === "checkbox" ? [] : "";
    if (blok.lainnya_key) out[blok.lainnya_key] = "";

    return out;
  }

  get maxKantong(): number {
    if (this.meta && this.meta.kantong) return this.meta.kantong.max;
    return 10;
  }

  get bisaTambahKantong(): boolean {
    return this.form.kantong.length < this.maxKantong;
  }

  private opsiReaksi(keys: string[]): any[] {
    const label = this.katalog.label_reaksi || {};
    return keys.map(k => ({ text: label[k] || k, value: k }));
  }

  get reaksiGolonganItems(): any[] {
    return this.opsiReaksi(this.katalog.reaksi_golongan || KOSONG);
  }

  get reaksiCrossItems(): any[] {
    return this.opsiReaksi(this.katalog.reaksi_crossmatch || KOSONG);
  }

  get reaksiCoombsItems(): any[] {
    return this.opsiReaksi(this.katalog.reaksi_coombs || KOSONG);
  }

  get golDarahItems(): any[] {
    return (this.katalog.gol_darah || KOSONG).slice();
  }

  get rhesusItems(): any[] {
    const map = this.katalog.rhesus || {};
    return Object.keys(map).map(k => ({ text: map[k], value: k }));
  }

  get metodeItems(): any[] {
    const map = this.katalog.metode || {};
    return Object.keys(map).map(k => ({ text: map[k], value: k }));
  }

  get hasilSilangItems(): any[] {
    const map = this.katalog.hasil_silang || {};
    return Object.keys(map).map(k => ({ text: map[k], value: k }));
  }

  get daftarOrder(): HasilDarahOrderKonteks[] {
    const orders = this.konteks ? this.konteks.orders : [];
    return orders.filter(o => o.jenis === this.jenisAktif);
  }

  get idOrderTersimpan(): number | null {
    if (!this.editData) return null;
    return this.pakaiPermintaanKomponen
      ? this.editData.permintaan_komponen_darah_id
      : this.editData.permintaan_bank_darah_id;
  }

  bisaDipilih(o: HasilDarahOrderKonteks): boolean {
    return o.status === "dikerjakan" || o.id === this.idOrderTersimpan;
  }

  get permintaanItems(): any[] {
    return this.daftarOrder.map(o => ({
      id: o.id,
      label: o.label + (o.status !== "dikerjakan" ? ` (${o.status_label})` : ""),
      disabled: !this.bisaDipilih(o)
    }));
  }

  get orderTerpilih(): HasilDarahOrderKonteks | null {
    const id = this.permintaanTerpilih;
    if (!id) return null;
    return this.daftarOrder.find(o => o.id === id) || null;
  }

  get hintPermintaan(): string {
    if (this.loadingKonteks) return "";
    if (!this.daftarOrder.some(o => this.bisaDipilih(o))) {
      return "Belum ada order berstatus Diproses — isi serah terima komponen/sampel terlebih dahulu";
    }
    return "Memilih permintaan mengisi Dokter, Ruang & Tanggal Daftar (tanggal order diterima)";
  }

  get pakaiPermintaanKomponen(): boolean {
    return this.jenisAktif === "komponen_darah";
  }

  get labelPermintaanTerkait(): string {
    const singkat = this.pakaiPermintaanKomponen
      ? "Komponen Darah"
      : this.meta
      ? this.meta.label_singkat
      : "";

    return singkat ? `Permintaan ${singkat} Terkait *` : "Permintaan Terkait *";
  }

  get permintaanTerpilih(): number | null {
    return this.pakaiPermintaanKomponen
      ? this.form.permintaan_komponen_darah_id
      : this.form.permintaan_bank_darah_id;
  }

  set permintaanTerpilih(val: number | null) {
    if (this.pakaiPermintaanKomponen) {
      this.form.permintaan_komponen_darah_id = val;
      this.form.permintaan_bank_darah_id = null;
    } else {
      this.form.permintaan_bank_darah_id = val;
      this.form.permintaan_komponen_darah_id = null;
    }
  }

  get daftarAt(): Date | null {
    return strToDate(this.form.daftar_at);
  }

  set daftarAt(val: Date | null) {
    this.form.daftar_at = dateToStr(val);
  }

  get hasilKeluarAt(): Date | null {
    return strToDate(this.form.hasil_keluar_at);
  }

  set hasilKeluarAt(val: Date | null) {
    this.form.hasil_keluar_at = dateToStr(val);
  }

  
  get pratinjauKesimpulan(): string {
    const rhesusMap = this.katalog.rhesus || {};
    const gol = this.form.gol_darah
      ? `Golongan darah pasien ${this.form.gol_darah}` +
        (this.form.rhesus ? ` Rh ${rhesusMap[this.form.rhesus] || this.form.rhesus}` : "")
      : "Golongan darah pasien belum disimpulkan";

    if (!this.adaBand("crossmatch")) return gol;

    const terisi = this.form.kantong.filter(k => !!k.hasil_uji_silang);

    if (!terisi.length) {
      return `${gol}. Kesimpulan darah donor belum dapat diturunkan (belum ada hasil uji silang serasi).`;
    }

    const adaInkompatibel = terisi.some(
      k => k.hasil_uji_silang === "inkompatibel"
    );

    return `${gol}, dan darah donor ${
      adaInkompatibel ? "Inkompatibel" : "Kompatibel"
    } dengan pasien. Kesimpulan ini dihitung otomatis dari hasil uji silang serasi.`;
  }

  emptyKantong(): HasilDarahKantong {
    seqKantong += 1;

    return {
      id: null,
      kode_kantong: null,
      komponen: null,
      komponen_lain: null,
      gol_darah: null,
      rhesus: null,
      mayor: null,
      minor: null,
      auto_kontrol: null,
      hasil_uji_silang: null,
      _k: `k-${seqKantong}`
    };
  }

  emptyForm(): HasilDarahForm {
    return {
      id: null,
      jenis: this.jenisAktif,
      permintaan_komponen_darah_id: null,
      permintaan_bank_darah_id: null,
      dokter_peminta_user_id: null,
      dokter_peminta_nama: null,
      jaminan_manual: null,
      bangsal: null,
      daftar_at: null,
      hasil_keluar_at: null,
      cg_anti_a: null,
      cg_anti_b: null,
      sg_sel_a: null,
      sg_sel_b: null,
      sg_sel_o: null,
      rh_anti_d: null,
      rh_balb6: null,
      gol_darah: null,
      rhesus: null,
      metode_crosstest: "gel_test",
      metode_lain: null,
      dct: null,
      ict: null,
      kesimpulan: null,
      saran: null,
      detail: this.emptyDetail(),
      petugas_user_id: null,
      dokter_pj_user_id: null,
      kantong: this.adaBand("crossmatch") ? [this.emptyKantong()] : []
    };
  }

  @Watch("value")
  onDialogToggle(val: boolean) {
    if (!val) return;

    storeHasilPemeriksaanDarah.loadKatalog();

    if (this.editData) {
      this.hydrate();
    } else {
      this.form = this.emptyForm();
      this.form.hasil_keluar_at = dateToStr(new Date());
      this.form.petugas_user_id = this.defaultPetugasId;
    }

    this.muatKonteks();
  }

  hydrate() {
    const d = this.editData;

    this.form = {
      ...this.emptyForm(),
      id: d.id,
      jenis: d.jenis,
      permintaan_komponen_darah_id: d.permintaan_komponen_darah_id,
      permintaan_bank_darah_id: d.permintaan_bank_darah_id,
      dokter_peminta_user_id: d.dokter_peminta_user_id,
      dokter_peminta_nama: d.dokter_peminta_nama,
      jaminan_manual: d.jaminan_manual,
      bangsal: d.bangsal,
      daftar_at: d.daftar_at,
      hasil_keluar_at: d.hasil_keluar_at,
      cg_anti_a: d.cg_anti_a,
      cg_anti_b: d.cg_anti_b,
      sg_sel_a: d.sg_sel_a,
      sg_sel_b: d.sg_sel_b,
      sg_sel_o: d.sg_sel_o,
      rh_anti_d: d.rh_anti_d,
      rh_balb6: d.rh_balb6,
      gol_darah: d.gol_darah,
      rhesus: d.rhesus,
      metode_crosstest: d.metode_crosstest,
      metode_lain: d.metode_lain,
      dct: d.dct,
      ict: d.ict,
      kesimpulan: d.kesimpulan || null,
      saran: d.saran,
      detail: { ...this.emptyDetail(), ...(d.detail || {}) },
      petugas_user_id: d.petugas_user_id,
      dokter_pj_user_id: d.dokter_pj_user_id,
      kantong: (d.kantong || []).map((k: any) => {
        const baris = this.emptyKantong();
        baris.id = k.id;
        baris.kode_kantong = k.kode_kantong;
        baris.komponen = k.komponen || null;
        baris.komponen_lain = k.komponen_lain || null;
        baris.gol_darah = k.gol_darah || null;
        baris.rhesus = k.rhesus || null;
        baris.dibatalkan = !!k.dibatalkan;
        baris.mayor = k.mayor;
        baris.minor = k.minor;
        baris.auto_kontrol = k.auto_kontrol;
        baris.hasil_uji_silang = k.hasil_uji_silang;
        return baris;
      })
    };

    if (!this.form.kantong.length && this.adaBand("crossmatch")) {
      this.form.kantong = [this.emptyKantong()];
    }
  }

  async muatKonteks() {
    if (!this.register) return;

    const register = this.register;
    this.loadingKonteks = true;

    try {
      const data = await HasilDarahSvc.konteks(register);
      if (String(register) !== String(this.register)) return;
      this.konteks = data;
      this.terapkanKonteks();
    } catch {
      this.konteks = null;
    } finally {
      this.loadingKonteks = false;
    }
  }

  terapkanKonteks() {
    if (!this.konteks || this.editData) return;

    if (!this.form.bangsal) this.form.bangsal = this.konteks.ruang || null;
    if (!this.form.jaminan_manual) this.form.jaminan_manual = this.konteks.jaminan || null;

    if (!this.permintaanTerpilih) {
      const siap = this.daftarOrder.filter(o => o.status === "dikerjakan");
      if (siap.length === 1) {
        this.permintaanTerpilih = siap[0].id;
        this.onPilihPermintaan(siap[0].id);
      }
    }
  }

  onPilihPermintaan(id: number | null) {
    if (!id) return;

    const order = this.daftarOrder.find(o => o.id === id);
    if (!order) return;

    if (!this.form.dokter_peminta_nama) {
      this.form.dokter_peminta_nama = order.dokter_peminta_nama || null;
    }

    if (!this.form.dokter_peminta_user_id && order.dokter_peminta_user_id) {
      this.form.dokter_peminta_user_id = order.dokter_peminta_user_id;
    }

    if (order.bangsal) {
      this.form.bangsal = order.bangsal;
    }

    if (order.diterima_at) {
      this.form.daftar_at = order.diterima_at;
    }

    if (order.macam.length === 1) {
      this.form.kantong.forEach(k => {
        if (!k.komponen) k.komponen = order.macam[0];
      });
    }
  }

  tambahKantong() {
    if (!this.bisaTambahKantong) return;
    const baris = this.emptyKantong();
    const order = this.orderTerpilih;
    if (order && order.macam.length === 1) baris.komponen = order.macam[0];
    this.form.kantong.push(baris);
  }

  hapusKantong(idx: number) {
    if (this.adaBand("crossmatch") && this.form.kantong.length <= 1) return;
    this.form.kantong.splice(idx, 1);
  }

  cekIsianWajib(): string | null {
    const kurang: string[] = [];

    if (!this.form.petugas_user_id) kurang.push("Petugas Pemeriksa");

    if (!this.editData && !this.permintaanTerpilih) kurang.push("Permintaan Terkait");

    if (this.kantongTanpaUji && this.form.kantong.some(k => !k.kode_kantong)) {
      kurang.push("No. Kantong");
    }

    if (this.adaBand("crossmatch")) {
      if (this.form.metode_crosstest === "lainnya" && !this.form.metode_lain) {
        kurang.push("Keterangan Metode Lainnya");
      }

      const kosong = this.form.kantong.filter(k => !k.kode_kantong);
      if (kosong.length) kurang.push("Kode / No. Kantong");
    }

    const blok = this.blok;
    if (blok && blok.tipe === "fields" && blok.fields) {
      const fields = blok.fields;
      const kunci = Object.keys(fields);

      for (let i = 0; i < kunci.length; i++) {
        const f = fields[kunci[i]];
        if (f.tipe !== "textarea" || !f.max_baris) continue;

        const isi = String(this.form.detail[kunci[i]] || "");
        if (!isi) continue;

        const baris = isi.split(/\r\n|\r|\n/).length;
        if (baris > f.max_baris) {
          return (
            `Kolom ${f.label} maksimal ${f.max_baris} baris agar cetakan ` +
            `tetap satu halaman (saat ini ${baris} baris).`
          );
        }
      }
    }

    if (blok && blok.tipe === "checkbox" && blok.key) {
      if (blok.required) {
        const dipilih = this.form.detail ? this.form.detail[blok.key] : null;
        if (!Array.isArray(dipilih) || !dipilih.length) kurang.push(blok.label);
      }

      if (
        this.pilihLainnya &&
        !String(this.form.detail[blok.lainnya_key as string] || "").trim()
      ) {
        kurang.push(blok.lainnya_label || "Keterangan Lainnya");
      }
    }

    if (
      this.form.daftar_at &&
      this.form.hasil_keluar_at &&
      this.form.hasil_keluar_at < this.form.daftar_at
    ) {
      return "Waktu hasil keluar tidak boleh lebih awal daripada waktu pendaftaran sampel.";
    }

    return kurang.length ? "Lengkapi dulu: " + kurang.join(", ") + "." : null;
  }

  buildPayload(): any {
    const payload: any = {
      register_id: this.register,
      pasien_rm: this.rm,
      jenis: this.jenisAktif
    };

    const kolom = [
      "permintaan_komponen_darah_id",
      "permintaan_bank_darah_id",
      "dokter_peminta_user_id",
      "dokter_peminta_nama",
      "jaminan_manual",
      "bangsal",
      "daftar_at",
      "hasil_keluar_at",
      "cg_anti_a",
      "cg_anti_b",
      "sg_sel_a",
      "sg_sel_b",
      "sg_sel_o",
      "rh_anti_d",
      "rh_balb6",
      "gol_darah",
      "rhesus",
      "metode_crosstest",
      "metode_lain",
      "dct",
      "ict",
      "saran",
      "kesimpulan",
      "petugas_user_id",
      "dokter_pj_user_id"
    ];

    kolom.forEach(k => {
      payload[k] = (this.form as Record<string, any>)[k];
    });

    if (this.blok) {
      payload.detail = this.form.detail;
    }

    if (this.adaBand("crossmatch") || this.kantongTanpaUji) {
      payload.kantong = this.form.kantong.map(k => ({
        kode_kantong: k.kode_kantong,
        komponen: k.komponen,
        komponen_lain: k.komponen === "lainnya" ? k.komponen_lain : null,
        gol_darah: k.gol_darah,
        rhesus: k.rhesus,
        mayor: k.mayor,
        minor: k.minor,
        auto_kontrol: k.auto_kontrol,
        hasil_uji_silang: k.hasil_uji_silang
      }));
    }

    return payload;
  }

  async simpan() {
    if (this.lockedForm || this.saving) return;

    const kurang = this.cekIsianWajib();
    if (kurang) {
      appModule.sendErrorAlert(kurang);
      return;
    }

    this.saving = true;
    try {
      const payload = this.buildPayload();

      const resp = this.form.id
        ? await HasilDarahSvc.update(this.form.id, payload)
        : await HasilDarahSvc.create(payload);

      if (resp.data.status == "1") {
        appModule.sendSuccessNotice(
          resp.data.message || "Hasil pemeriksaan tersimpan"
        );

        const tersimpan = resp.data.data;

        this.dialog = false;
        this.$emit("saved", tersimpan);
      }
    } catch {
      return;
    } finally {
      this.saving = false;
    }
  }

  tutup() {
    this.dialog = false;
  }
}
